import IconComponent from "icons/IconComponent";

import CreditCardIcon from "./credit-card.svg";

export default (CreditCardIcon as any) as IconComponent;
